/* eslint @typescript-eslint/naming-convention: 0 */
import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

/** クリックした検索結果 hit の種別。ファネル②の直行 / 回遊の分岐キー */
export type SearchResultType = 'experience' | 'tag' | 'feature' | 'destinationTheme';

export interface SearchResultClickParams {
  /** PII ガード済みの入力キーワード（正規化後。送信抑止時は空文字） */
  keyword: string;
  result_type: SearchResultType;
  /** 遷移先キー（体験 slug / タグ webPath / 特集 slug / Destination×Theme webPath） */
  clicked_slug: string;
  /** tag hit の場合のグループ種別（destination / theme / preference 等） */
  tag_group_type?: string;
  /** クリックされた結果の表示順位（Algolia hit.__position） */
  position?: number;
}

export interface SearchResultClickInput {
  keyword: string;
  resultType: SearchResultType;
  clickedSlug: string;
  tagGroupType?: string;
  position?: number;
}

const buildSearchResultClickParams = (input: SearchResultClickInput): SearchResultClickParams => {
  return {
    keyword: input.keyword,
    result_type: input.resultType,
    clicked_slug: input.clickedSlug,
    ...(input.tagGroupType !== undefined ? { tag_group_type: input.tagGroupType } : {}),
    ...(input.position !== undefined ? { position: input.position } : {}),
  };
};

/**
 * 発火タイミング：検索結果の hit をクリックして遷移した際。
 * ※ ファネルの「段」には使わず（直後の page_view と 1:1 で重複するため）、売上帰属タグ付けと順位計測に使う。
 */
export const sendGAWabunkaSearchResultClickEvent = (input: SearchResultClickInput) => {
  sendWabunkaGAEvent('search_result_click', buildSearchResultClickParams(input));
};
